var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomToolboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.25V2.99737L2.25 2.99737C1.00736 2.99737 0 4.00473 0 5.24737L0 13.7442C0 14.9868 1.00736 15.9942 2.25 15.9942L17.75 15.9942C18.9926 15.9942 20 14.9868 20 13.7442V5.24737C20 4.00473 18.9926 2.99737 17.75 2.99737H15V2.25C15 1.00736 13.9926 0 12.75 0L7.25 0C6.00736 0 5 1.00735 5 2.25ZM7.25 1.5L12.75 1.5C13.1642 1.5 13.5 1.83578 13.5 2.25V2.99737L6.5 2.99737V2.25C6.5 1.83578 6.83579 1.5 7.25 1.5ZM5 4.5H6.5V4.49737L13.5 4.49737V4.5H15V4.49737H17.75C18.1642 4.49737 18.5 4.83316 18.5 5.24737V7.49741H15.5V6.74741C15.5 6.33311 15.1642 5.99741 14.75 5.99741C14.3358 5.99741 14 6.33311 14 6.74741V7.49741L6 7.49741L6 6.74741C6 6.33311 5.66421 5.99741 5.25 5.99741C4.83579 5.99741 4.5 6.33311 4.5 6.74741L4.5 7.49741H1.5L1.5 5.24737C1.5 4.83316 1.83579 4.49737 2.25 4.49737H5V4.5ZM14 8.99741V10.2474C14 10.6616 14.3358 10.9974 14.75 10.9974C15.1642 10.9974 15.5 10.6616 15.5 10.2474V8.99741H18.5V13.7442C18.5 14.1584 18.1642 14.4942 17.75 14.4942L2.25 14.4942C1.83579 14.4942 1.5 14.1584 1.5 13.7442L1.5 8.99741H4.5V10.2474C4.5 10.6616 4.83579 10.9974 5.25 10.9974C5.66421 10.9974 6 10.6616 6 10.2474V8.99741H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomToolboxActive);
export default __webpack_public_path__ + "static/media/bottom_toolbox_active.389bb9baac38bc8ccf6223457317eac2.svg";
export { ForwardRef as ReactComponent };